import { Box } from '../../../../primitives/Box/Box.es.js';
import 'react';
import '../../../../primitives/Center/styled.es.js';
import '../../../../primitives/Group/Group.es.js';
import '../../../../primitives/Grid/Grid.es.js';
import '../../../../primitives/Level/Level.es.js';
import '../../../../primitives/Shelf/Shelf.es.js';
import '../../../../primitives/Portal/Portal.es.js';
import '../../../../primitives/Hidden/Hidden.es.js';
import '../../../../primitives/Media/Media.es.js';
import '../../../../primitives/Dialog/Dialog.es.js';
import '../../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../../primitives/Popper/Popper.es.js';
import '../../../../primitives/DragHandle/DragHandle.es.js';
import '../../../../primitives/Pin/Pin.es.js';
import '../../../../utils/assertions.es.js';
import '../../../../utils/responsive.es.js';
import '../../../../utils/scrollIntoView.es.js';
import { themeMode, spacing, shadow, radius, color } from '../../../../utils/theme.es.js';
import '../../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';

const Dropdown = styled(Box)`
    background-color: ${themeMode({
  light: color("neutral.0"),
  dark: color("neutral.800")
})};
    display: flex;
    flex-direction: column;
    max-height: 192px;
    overflow: hidden;
    z-index: 1000;
    margin: ${spacing("xs")} auto;
    box-shadow: ${shadow("3")};
    border-radius: ${radius("base")};
`;

export { Dropdown };
//# sourceMappingURL=styled.es.js.map
